import React, { useState, useEffect, useMemo } from 'react'
import Select from 'react-select'
import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormInput, CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CRow } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus, View, Eye } from 'lucide-react'

import Pageloader from '../../components/shared/Pageloader'
import PatientInfo from './PatientInfo'
import PatientDataCRUD from '../../services/general/patientNoteData.api'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import SavePatients from '../../services/general/savePatientinformation.api'
import { HiEye } from 'react-icons/hi'
import SaveExtra from '../../services/general/saveExtraData.api'
import classNames from 'classnames'
import PatientInfoFreeType from './PatientInfoFreetype'

// showing only those on popup which are signed or finished aas discussed on 6aug and only visible on popup
const PatientPopSignedChart = ({
  patientData,
  noteStructureRef,
  showCreateNote = true,
  setAppointmentDetails = false,
  setNoteStatus,
  noteStatus,
  patientID,
  setPatientModalVisible,
  setDataCallType,
  showNoteJustThisId,
  setShowPatientInfo,
  setEditDataId,
  setNoteID,
  showOnlyViewEye = false,
  childformData,
  setChildFormData,
  saveDiagnosisData,
  resetStates,
  setAllSelectedDiagnosis,
  breadCrumbHref,
  breadCrumbText,
  patientAppointmentID,
  appointment,
  viewPatientDetail,
  creatingNewNote,
  setCreatingNewNote,
  handleAddNoteId,
  showViewIcon = false,
  allAppointment,
  onInitialLoadSettled,
}) => {
  const [diagnosisData, setDiagnosisData] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [boxView, setBoxView] = useState('box')
  const [warningModelVisible, setWarningModelVisible] = useState(false)
  const [patientTreatments, setPatientTreatments] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [allowCreateNote, setAllowCreateNote] = useState(true)
  const [allPatientVisible, setAllPatientVisible] = useState(false)
  const [showNotePatient, setShowNotePatient] = useState(false)
  const [noteId, setNodeId] = useState(null)
  const [noteIndex, setNoteIndex] = useState(false)
  const [finishNote, setFinishNote] = useState({})
  const [hasFinishNote, setHasFinishNote] = useState(false)
  const [patientAllAppointment, setPatientAllAppointment] = useState([])
  const displayedPatientTreatments = useMemo(() => {
    if (!Array.isArray(patientTreatments)) return []

    return patientTreatments.map((item, originalIndex) => ({ item, originalIndex })).reverse()
  }, [patientTreatments])

  // const getPatientDiagnosis = async () => {
  //     let diagnosisData = await ModifyPatientMap("GETALL", patientID, "")
  //     let tempData = JSON.parse(diagnosisData.d)?.Data

  //     diagnosisData = tempData.filter(obj => { if (patientID == obj.PatientID) { return obj } })
  //     let patientD = []
  //     try {
  //         patientD = diagnosisData[0]?.Diagnosis?.split(',')
  //         console.log("patinent diagnosis data", patientD)
  //          setAllSelectedDiagnosis(patientD)
  //     } catch (e) {

  //     }

  // }

  // const patientDataFn = async () => {
  //     setIsPageLoading(true)
  //     try {
  //         let patientData = await SavePatients("GetAll", "", "", "");
  //         setPatientData(JSON.parse(patientData.d).Data);

  //     } catch (error) {
  //         console.log(error)
  //     } finally {
  //         setIsPageLoading(false)
  //     }
  // }
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const GetPatientTreatmentsNotes = async () => {
    if (!patientID) {
      setPatientTreatments([])
      onInitialLoadSettled?.()
      return []
    }

    setIsPageLoading(true)
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)
      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data.map((item) => {
          return {
            ...item,
            data: item.data ? JSON.parse(item?.data) : {},
          }
        })
        setPatientTreatments(
          data,
          // data?.filter(
          //   (item) =>
          //     (item.status === "Finished" || item.status === "Signed")
          //   // && item.id === showNoteJustThisId
          // )
        )

        // setPatientTreatments(data?.filter((item) => item.status === 'Finished' || item.status === 'Signed') && item.id === showNoteJustThisId)
        return data
      }
    } catch (error) {
      toast.error('error in patient treatment', toastConfig)
    } finally {
      setIsPageLoading(false)
      onInitialLoadSettled?.()
    }
  }

  const Finish = () => {
    let finishNote = patientTreatments?.filter((item) => item.status === 'Finished')
    if (finishNote && finishNote?.length > 0) {
      setFinishNote(finishNote[finishNote.length - 1] || {})
    }
  }

  useEffect(() => {
    const patientDataFn = async () => {
      setPatientTreatments([])
      setPatientAllAppointment([])
      setAllowCreateNote(true)
      setAllPatientVisible(false)
      setShowNotePatient(false)
      setNodeId(null)
      setNoteIndex(null)
      await GetPatientTreatmentsNotes()
    }
    patientDataFn()
  }, [patientID, patientData])

  const deleteShall = async (id) => {
    // const formattedJson = JSON.stringify(noteStructureRef.current)
    await PatientDataCRUD('DELETE', patientID.toString(), id.toString())
    await GetPatientTreatmentsNotes()
    setDeleteVisibleId(null)
  }
  useEffect(() => {
    Finish()
  }, [patientTreatments])

  const handleCreateNote = async () => {
    setCreatingNewNote(true)
    await PatientNoteDataCRUD('INSERT', patientID.toString(), '', JSON.stringify(noteStructureRef.current), getFormattedDate().toString())
    const patientTreatments = await GetPatientTreatmentsNotes()
    let recentlyCreatedNote
    if (patientTreatments.length > 1) {
      saveDiagnosisData({
        ...patientData,
        Status: 'Follow Up',
      })

      setNoteStatus('Follow Up')
    }
    if (patientTreatments.length > 0) {
      recentlyCreatedNote = patientTreatments[patientTreatments.length - 1]
      setEditDataId(recentlyCreatedNote?.id)
    }
    if (patientTreatments?.length !== 0) {
      setChildFormData((prev) => {
        return { ...prev, Status: 'Follow Up' }
      })

      let result = patientTreatments && patientTreatments.every((item) => item.status !== 'Signed')
      if (result) {
        setWarningModelVisible(true)
        setNoteID(patientTreatments.length - 1)
        SyncAppointmentData(recentlyCreatedNote?.id)
        setEditDataId(recentlyCreatedNote?.id)
        setDataCallType('edit')
        if (patientData?.Status === 'Follow Up') {
          //this is for case if the note id is 0 and patient created as followup then the hpi should not show, it should show the subjective, so for that we need to set the notestatus as followup.
          setNoteStatus('Follow Up')
        }
      } else {
        setEditDataId(recentlyCreatedNote?.id)
        setDataCallType('edit')
        setShowPatientInfo(true)
        setPatientModalVisible(false)
        setNoteID(patientTreatments.length - 1)
        SyncAppointmentData(recentlyCreatedNote?.id)
      }
    } else {
      console.log('else run')
      setChildFormData((prev) => {
        return { ...prev, Status: 'NewPatient' }
      })
      SyncAppointmentData(recentlyCreatedNote?.id)
      setNoteID(0)
      setDataCallType('newNote')
      setShowPatientInfo(true)
      setPatientModalVisible(false)
    }
  }

  useEffect(() => {
    if (patientTreatments && patientTreatments.length === 0) {
      setAllowCreateNote(false)
    }

    if (patientTreatments && patientTreatments.length > 0) {
      let appoinmentsData = appointment.filter((item) => item.data.AppointmentID === patientAppointmentID)

      let patientStatus = patientTreatments[patientTreatments.length - 1].status
      // if (patientStatus === 'Finished' && (appoinmentsData.length > 0 && !appoinmentsData[0].data.NoteID)) {
      //       setAllowCreateNote(false)
      //   }
      if (patientStatus === 'Finished' || patientStatus === 'Canceled') {
        setAllowCreateNote(false)
      }
    }
  }, [patientTreatments, patientData])

  const handleNoteView = (item, index) => {
    setAllPatientVisible(true)
    setNodeId(item.id)
    setNoteIndex(index)
  }

  const SyncAppointmentData = (noteID) => {
    if (noteID === null || noteID === undefined) return

    const targetAppointment = appointment?.find((item) => item?.data?.AppointmentID === patientAppointmentID)
    if (!targetAppointment || targetAppointment?.data?.NoteID) return

    let filterPatient = appointment && appointment.length > 0 && appointment.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled') && !item.data.NoteID)

    if (filterPatient.length > 0) {
      handleAddNoteId(noteID)
    }
  }

  useEffect(() => {
    const getData = () => {
      let filtered = allAppointment?.filter(
        (entry) => entry.patientID === patientID,
        // entry.appointmentDetails.find((appt) => appt.data?.Status === "Finish")
      )

      setPatientAllAppointment(filtered?.length > 0 ? filtered[0].appointmentDetails : [])
      // setHasFinishNote(filtered)
    }
    getData()
  }, [allAppointment, patientID])

  const getNoteStatus = (item, index, patientData, appointmentDetails) => {
    const matchedAppointments = appointmentDetails?.filter((appt) => appt.data?.NoteID === item.id)

    const latestAppointment = matchedAppointments?.length ? matchedAppointments.sort((a, b) => new Date(b.data.CreatedDate) - new Date(a.data.CreatedDate))[0] : null
    return (latestAppointment?.data?.Type == 'New' ? 'New Note' : `Follow Up`) || 'New Note'
  }

  const getNoteStatusLabel = (item, index, patientData, appointmentDetails) => {
    const matchedAppointments = appointmentDetails?.filter((appt) => appt.data?.NoteID === item.id)

    const latestAppointment = matchedAppointments?.length ? matchedAppointments.sort((a, b) => new Date(b.data.CreatedDate) - new Date(a.data.CreatedDate))[0] : null

    const type = latestAppointment?.data?.Type

    if (type === 'New') {
      return 'New Note'
    }

    if (type === 'Follow Up') {
      return index === 0 ? 'Follow Up' : `${index} Follow Up`
    }

    return index === 0 ? 'New Note' : `${index} Follow Up`
  }

  return (
    <>
      <div>
        <CCard className="m-2" style={{ border: 'none' }}>
          <CCardBody className="p-0">
            {showCreateNote && (
              <div className="d-flex align-items-center ">
                {/* <CButton
                  onClick={handleCreateNote}
                  variant="outline"
                  color="primary"
                  disabled={allowCreateNote}
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    opacity: allowCreateNote ? 0.5 : 1,
                    pointerEvents: allowCreateNote ? 'none' : 'auto',
                    borderColor: 'var(--cui-primary)',
                  }}
                >
                  <CirclePlus size={16} strokeWidth={1.25} />
                  <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>Create Note</div>
                </CButton> */}
              </div>
            )}
          </CCardBody>
        </CCard>

        <div className="px-1 overflow-auto" style={{ height: '60vh' }}>
          <div className="py-2">
            <CRow className="gy-3">
              {displayedPatientTreatments.map(({ item, originalIndex }) => (
                  <CCol sm={12} className="d-flex">
                    <CCard className="w-100 shadow-sm patient-theme-card" style={{ borderRadius: '12px' }}>
                      <CCardHeader className="d-flex justify-content-between align-items-center patient-theme-card-header" style={{ padding: '14px 16px' }}>
                        <h6 className="m-0 patient-theme-card-title">{getNoteStatusLabel(item, originalIndex, patientData, patientAllAppointment)}</h6>
                        <div className="d-flex align-items-center gap-1">
                          <button onClick={() => handleNoteView(item, originalIndex)} className="patient-note-card-action-btn" title="View Note">
                            <Eye size={16} />
                          </button>
                        </div>
                      </CCardHeader>
                      <CCardBody className="p-3">
                        <div className="patient-theme-card-body-text">
                          <div>Date: {new Date(item.date).toLocaleDateString('en-us')}</div>
                          {item.flag == 'true' && item.status == 'Draft' ? <div>Status: Provider {item.status}</div> : item.flag == 'true' && item.status == 'Signed' ? <div>Status: Provider {item.status}</div> : <div>Status: {item.status}</div>}
                          {item.status === 'Canceled' && (
                            <div>
                              Reason:{' '}
                              {(() => {
                                return item?.data?.NoteCancelReason || 'N/A'
                              })()}
                            </div>
                          )}
                        </div>
                      </CCardBody>
                    </CCard>
                  </CCol>
                ))}
            </CRow>
          </div>
        </div>

        {/* delete modal */}
        <CModal visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={() => deleteShall(deleteId)} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={warningModelVisible}
          onClose={() => {
            ;(setWarningModelVisible(false), setWarningModelVisible(false))
          }}
        >
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to create new note?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setWarningModelVisible(false)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton
              onClick={() => {
                setDataCallType('newNote')
                setShowPatientInfo(true)
                setPatientModalVisible(false)
              }}
              className="text-white"
              color="warning"
            >
              Continue
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          size="xl"
          visible={allPatientVisible}
          className="dashboard-dark-modal patient-theme-modal patient-all-data-modal"
          onClose={() => {
            ;(setAllPatientVisible(false), setShowNotePatient(false), setNodeId(null), setNoteIndex(null))
          }}
        >
          <CModalHeader>
            <CModalTitle>Note</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div style={{ height: '45vw', overflow: 'auto' }}>
              {patientData ? (
                <PatientInfoFreeType
                  setAppointmentDetails={setAppointmentDetails}
                  breadCrumbHref={breadCrumbHref}
                  breadCrumbText={breadCrumbText}
                  patientID={patientData.PatientID}
                  patientData={patientData}
                  dataCallType="edit"
                  setDataId={noteId}
                  noteID={noteIndex}
                  showAllData={false}
                  showNoteView={true}
                  appointments={appointment}
                />
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100 text-secondary">Loading patient note...</div>
              )}
            </div>
          </CModalBody>

          <CModalFooter>
            <CButton
              onClick={() => {
                setAllPatientVisible(false)
                setShowNotePatient(false)
                setNodeId(null)
                setNoteIndex(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
          </CModalFooter>
        </CModal>
        <Pageloader isLoading={isPageLoading} />
      </div>
    </>
  )
}

export default PatientPopSignedChart
